import React, { useState } from 'react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';

const PROXY = process.env.REACT_APP_API_URL + 'api/';

const GenerateRetailSampleFile = ({ leadType }) => {
    const [loading, setLoading] = useState(false);

    const getFileName = () => {
        const getCurrentDateTimeIST = () => {
            const date = new Date();

            const options = {
                timeZone: 'Asia/Kolkata',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            };

            const formatter = new Intl.DateTimeFormat('en-IN', options);
            const parts = formatter.formatToParts(date);

            const getPart = (type) => parts.find((part) => part.type === type)?.value;

            const year = getPart('year');
            const month = getPart('month');
            const day = getPart('day');
            const hour = getPart('hour');
            const minute = getPart('minute');
            const dayPeriod = getPart('dayPeriod');

            return `${day}-${month}-${year}_Time_${hour}:${minute}_${dayPeriod}`;
        };

        const currentDateTime = getCurrentDateTimeIST();
        return `sample_${leadType}-retailed-${currentDateTime}.xlsx`;
    };

    const handleGenerateFile = async () => {
        try {
            setLoading(true);
            const apicalling = PROXY + 'leads/generate-retail-sample';

            const response = await axios.get(apicalling, {
                responseType: 'blob'
            });

            if (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', getFileName());
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                setLoading(false);
                toast.success('Sample file generated successfully');
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error generating sample file:', error);
            toast.error('Failed to generate sample file');
        }
    };

    return (
        <>
            <button
                onClick={handleGenerateFile}
                disabled={loading}
                style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
            >
                {loading ? 'Generating...' : 'Generate Sample File'}
            </button>
            <Toaster position="top-right" reverseOrder={false} />
        </>
    );
};

export default GenerateRetailSampleFile;
